import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfflineApiListComponent } from './offline-api-list.component';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';



@NgModule({
  declarations: [
    OfflineApiListComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,

  ],
  exports:[
    OfflineApiListComponent
  ]
})
export class OfflineApiListModule { }
